"use server";
import { createSafeActionClient } from "next-safe-action";
import { z } from "zod";
import { randomUUID } from "node:crypto";
import { cookies } from "next/headers";
import { revalidatePath } from "next/cache";
import {
  cancelBooking,
  decideBookingCancellation,
  listCancellationReviews,
} from "@workspace/booking";
import { teacherAction } from "@/lib/teacher-action";
import { getCurrentMiniAppUser } from "@/lib/auth";
import { getMiniAppStoreId } from "@/lib/store";
async function refresh() {
  (await cookies()).set("miniapp_data_revision", randomUUID(), {
    httpOnly: true,
    sameSite: "lax",
    path: "/",
  });
  revalidatePath("/", "layout");
}
export const teacherCancellationListAction = teacherAction
  .schema(z.object({}))
  .action(async ({ ctx }) =>
    listCancellationReviews(ctx.storeId, ctx.teacher.id),
  );
export const teacherCancellationDecisionAction = teacherAction
  .schema(
    z.object({
      bookingId: z.string().uuid(),
      decision: z.enum(["REFUND", "DEDUCT"]),
      reason: z.string().trim().min(1).max(1000),
    }),
  )
  .action(async ({ ctx, parsedInput }) => {
    const result = await decideBookingCancellation({
      ...parsedInput,
      storeId: ctx.storeId,
      actor: { userId: ctx.user.id, teacherId: ctx.teacher.id },
    });
    await refresh();
    return result;
  });
export const requestStudentCancellationAction = createSafeActionClient({
  handleServerError: (error) =>
    error.message === "已開始的課程請聯絡老師處理"
      ? error.message
      : "取消未完成，請重新整理或聯絡老師。",
})
  .schema(z.object({ bookingId: z.string().uuid() }))
  .action(async ({ parsedInput }) => {
    const [storeId, user] = await Promise.all([
      getMiniAppStoreId(),
      getCurrentMiniAppUser(),
    ]);
    if (!storeId || !user || user.storeId !== storeId)
      throw new Error("請先登入");
    const result = await cancelBooking({
      storeId,
      bookingId: parsedInput.bookingId,
      reason: "學員從 MiniApp 申請取消",
      actor: { userId: user.id },
    });
    await refresh();
    return result;
  });
